import {registerAPIService} from './APIServicesRegistry';
import APIServiceBase from './APIServiceBase';

export default class LanguageApiService extends APIServiceBase {
    constructor() {
        super('Language')
    }

    setApplicationLanguage(data) {
        return this.post('SetApplicationLanguage', data)
    }
}

registerAPIService(LanguageApiService)